<template>
  <modal v-bind="$attrs" v-on="$listeners">
    <div slot="header"><h6>{{$t('invoice-line.create.title')}} {{client.name}}</h6></div>
    <form @submit.prevent="submit">
      <div class="row">
        <div class="col-12">
          <fg-input :placeholder="$t('invoice.edit.modal.name')"
                    :label="$t('invoice.edit.modal.name')"
                    :name="$t('invoice.edit.modal.name')"
                    v-model="model.name">
          </fg-input>
        </div>

        <div class="col-12">
          <fg-input :placeholder="$t('invoice.edit.modal.price_ex')"
                    :name="$t('invoice.edit.modal.price_ex')"
                    :error="getError($t('invoice.edit.modal.price_ex'))"
                    :label="`${$t('invoice.edit.modal.price_ex')} (${currencySymbol})`"
                    v-validate="modelValidations.price_ex"
                    type="number"
                    v-model="model.price_ex">
          </fg-input>
        </div>

        <div class="col-12">
          <fg-input :error="getError($t('invoice.edit.modal.product'))"
                    :label="$t('invoice.edit.modal.product')">
            <el-select class="select-default"
                       :name="$t('invoice.edit.modal.product')"
                       :placeholder="$t('invoice.edit.modal.product')"
                       :error="getError($t('invoice.edit.modal.product'))"
                       v-validate="modelValidations.product_id"
                       v-model="model.product_id"
                       @change="onProductChange"
                       filterable
                       clearable>
              <el-option class="select-default"
                         v-for="option in creditProducts"
                         :value="option.product_id"
                         :label="option.name"
                         :key="option.product_id">
              </el-option>
            </el-select>
          </fg-input>
        </div>
        <div class="flex w-full justify-center">
          <submit-button native-type="submit" :loading="loading"/>
        </div>
      </div>

    </form>
  </modal>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import { mapGetters, mapState } from 'vuex'
  import Modal from 'src/components/Modal'

  export default {
    name: 'invoice-line-modal',
    components: {
      Modal,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      client: {
        type: Object,
        default: () => ({})
      },
      loading: Boolean,
    },
    data () {
      return {
        model: {
          price_ex: 0,
          client_uuid: '',
          product_id: '',
          invoice_uuid: this.$route.params.id,
        },
        modelValidations: {
          product_id: {
            required: true
          },
          price_ex: {
            min_value: 0,
            numeric: true
          }
        }
      }
    },
    computed: {
      ...mapGetters('config', ['creditProducts']),
      ...mapState({
        currencySymbol: state => state.config.currencySymbol
      })
    },
    methods: {
      onProductChange (productId) {
        let product = this.creditProducts.find(p => p.product_id === productId)
        if (product) {
          this.model.price_ex = product.price
        }
      },
      getError (name) {
        return this.errors.first(name)
      },
      async submit () {
        let res = await this.$validator.validateAll()
        if (res) {
          this.$emit('save', this.model)
        }
      }
    },
    created () {
      this.$watch('client', newVal => {
        this.model.client_uuid = newVal.uuid
      }, {immediate: true})
    }
  }
</script>
<style>
</style>
